import { gql } from '@apollo/client';
import { DocumentFragment } from 'approot/shared/graphql/document/document.graphql';

export const studentLessonWorksheetsFragment = gql`
  fragment StudentLessonWorksheetsFragment on Lesson {
    id
    worksheet {
      id
      document {
        ...documentFragment
      }
    }
  }
  ${DocumentFragment}
`;
